'use client';

import { useWebView } from '../../hooks';
import { AdyenDataCollectionScript, AfterPayScript, MedalliaScript, UsableNetScript } from '../../scripts';

export function BodyStartScripts() {
    const isWebView = useWebView();

    return (
        <>
            {!isWebView && <MedalliaScript />}
            <AdyenDataCollectionScript />
            <AfterPayScript />
            <UsableNetScript />
        </>
    );
}
